<template>
  <div class="user">
    <!-- 原有开关设置 -->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
      
      <!-- 新增VIP平台介绍输入框 -->
      <el-form-item label="VIP平台介绍">
        <el-input
          type="textarea"
          :rows="4"
          v-model="form.platform_intro"
          placeholder="请输入VIP平台介绍内容"
          style="width: 400px;"
        ></el-input>
        <div class="form-tips">此处填写VIP平台的详细介绍，用于前台展示</div>
      </el-form-item>
    </el-form>

    <!-- 新增轮播图管理 -->
    <div class="banner-manage">
      <div class="banner-header">
        <h3>轮播图管理</h3>
        <el-button size="small" type="primary" @click="addBanner"
          >添加轮播图</el-button
        >
      </div>

      <!-- 轮播图列表 -->
      <div class="banner-list">
        <div class="banner-item" v-for="(item, index) in banners" :key="index">
          <!-- 轮播图预览（与图片样式完全一致） -->
          <div class="banner-preview" :style="{ background: '#e6f7ff' }">
            <img v-if="item.image" :src="item.image" class="banner-img" />
            <div v-else class="banner-placeholder">
              <i class="el-icon-picture"></i>
              <div>请上传图片</div>
            </div>
          </div>

          <!-- 配置区域 -->
          <div class="banner-config">
            <el-input
              v-model="item.link"
              placeholder="跳转地址"
              style="width: 70%"
            >
              <el-button slot="append" @click="selectLink(index)"
                >选择链接</el-button
              >
            </el-input>
            <el-button @click="removeBanner(index)" type="danger" plain
              >删除</el-button
            >
          </div>
          <div class="banner-text-input">
            <el-input
              v-model="item.description"
              placeholder="请输入轮播图描述文字"
              style="margin-top: 10px;"
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存按钮 -->
    <div class="common-button-wrapper">
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
        :loading="loading"
        >保存</el-button
      >
    </div>

    <!-- 图片上传组件 -->
    <upload
      v-if="showUpload"
      :config="{ total: 1 }"
      @returnImgs="handleImageUpload"
      @close="showUpload = false"
    ></upload>

    <!-- 新增链接选择组件 -->
    <Setlink
      v-if="isLinkSet"
      :is_linkset="isLinkSet"
      @closeDialog="closeLinkSet"
    ></Setlink>
  </div>
</template>

<script>
import Vip_serviceApi from "@/api/vip_service.js";
import Upload from "@/components/file/Upload";
import Setlink from "@/components/setlink/Setlink";

export default {
  components: {
    Upload,
    Setlink
  },
  data() {
    return {
      form: { 
        status: false,
        platform_intro: "" // 新增平台介绍字段
      },
      banners: [],
      loading: false,
      showUpload: false,
      isLinkSet: false, // 控制链接选择弹窗
      currentBannerIndex: 0
    };
  },
  created() {
    this.getSetting();
  },
  methods: {
    getSetting() {
      Vip_serviceApi.getSetting().then(res => {
        if (res.data.vars.values) {
          this.banners = res.data.vars.values.banners.map(banner => {
            return {
              ...banner,
              description: banner.description || "" // 确保每个banner都有description属性
            };
          });
          
          // 设置平台介绍
          if (res.data.vars.values.platform_intro) {
            this.form.platform_intro = res.data.vars.values.platform_intro;
          }
        }

        if (res.data.status) {
          this.form.status = res.data.status;
        }
      });
    },
    onSubmit() {
      this.loading = true;
      Vip_serviceApi.saveSetting({
        status: this.form.status,
        platform_intro: this.form.platform_intro, // 新增平台介绍
        banners: this.banners
      }).then(() => {
        this.$message.success("保存成功");
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    addBanner() {
      this.banners.push({
        image: "",
        link: "",
        description: ""
      });
      this.currentBannerIndex = this.banners.length - 1;
      this.showUpload = true;
    },
    removeBanner(index) {
      this.$confirm("确定删除该轮播图？", "提示", { type: "warning" }).then(
        () => this.banners.splice(index, 1)
      );
    },
    selectLink(index) {
      this.currentBannerIndex = index;
      this.isLinkSet = true;
    },
    closeLinkSet(e) {
      this.isLinkSet = false;
      if (e) {
        this.banners[this.currentBannerIndex].link = e.url;
      }
    },
    handleImageUpload(imgs) {
      if (imgs && imgs.length > 0) {
        this.banners[this.currentBannerIndex].image = imgs[0].file_path;
      }
      this.showUpload = false;
    }
  }
};
</script>

<style scoped>
.banner-manage {
  margin-top: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}
.banner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.banner-header h3 {
  margin: 0;
  color: #303133;
  font-weight: 600;
}
.banner-item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.banner-preview {
  position: relative;
  height: 180px;
  margin-bottom: 15px;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-img {
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}
.banner-placeholder {
  text-align: center;
  color: #909399;
}
.banner-placeholder i {
  font-size: 40px;
  margin-bottom: 10px;
  display: block;
}
.banner-config {
  display: flex;
  align-items: center;
  gap: 10px;
}
.banner-config .el-button {
  margin-left: 0;
}
.banner-text-input {
  margin-top: 10px;
}
.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #eee;
}
.form-tips {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .el-form-item__label {
    width: 120px !important;
  }
  
  .el-form-item__content {
    margin-left: 120px !important;
  }
  
  .banner-config {
    flex-direction: column;
    align-items: stretch;
  }
  
  .banner-config .el-input {
    width: 100% !important;
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/vip_service/setting/getSetting.vue